var data = [
	{
		layers: [
			{
				name: "Metal - Steel 43-275"
			}
		],
		modCategory: "PFC",
		modType: "02",
		modulousId: "PFC|02|",
		rgTypes: [
			"Beam"
		],
		rvFamilyName: "pfc-parallel flange channels [framing]",
		rvFamilyType: "pfc_230x90x32",
		size: [
			null,
			0.23000049591064453,
			0.09000015258789062
		],
		color: "#8e3939",
		sizeLock: [
			false,
			true,
			true
		]
	},
	{
		layers: [
			{
				name: "Metal - Steel 43-275"
			}
		],
		modCategory: "PFC",
		modType: "03",
		modulousId: "PFC|03|",
		rgTypes: [
			"Beam"
		],
		rvFamilyName: "pfc-parallel flange channels [framing]",
		rvFamilyType: "pfc_125x65x15",
		size: [
			null,
			0.125,
			0.06500005722045898
		],
		color: "#8e3939",
		sizeLock: [
			false,
			true,
			true
		]
	},
	{
		layers: [
			{
				name: "Metal - Steel 43-275"
			}
		],
		modCategory: "PFC",
		modType: "04",
		modulousId: "PFC|04|",
		rgTypes: [
			"Beam"
		],
		rvFamilyName: "pfc-parallel flange channels [framing]",
		rvFamilyType: "pfc_100x50x10",
		size: [
			null,
			0.10000038146972656,
			0.05000019073486328
		],
		color: "#8e3939",
		sizeLock: [
			false,
			true,
			true
		]
	},
	{
		layers: [
			{
				name: "Brick, Common",
				thickness: 0.036
			},
			{
				name: "Air",
				thickness: 0.066
			},
			{
				name: "Insulation_Generic_Rigid_Beige",
				thickness: 0.26
			}
		],
		modCategory: "FCD",
		modType: "02",
		modulousId: "FCD|02|",
		rgTypes: [
			"Wall"
		],
		rvFamilyName: "basic wall",
		rvFamilyType: "wall-cladd_36cld-66air-260ins",
		totalThickness: 0.362,
		size: [
			null,
			null,
			0.362
		],
		color: "#e6e0c8",
		sizeLock: [
			false,
			false,
			true
		]
	},
	{
		layers: [
			{
				name: "Sheathing Board_Knauf",
				thickness: 0.0125
			},
			{
				name: "Insulation_Generic_Rigid_Beige",
				thickness: 0.1
			},
			{
				name: "Sheathing Board_Knauf",
				thickness: 0.0125
			},
			{
				name: "Insulation_Generic_Rigid_Beige",
				thickness: 0.054
			},
			{
				name: "Metal - Aluminum",
				thickness: 0.006
			}
		],
		modCategory: "PAR",
		modType: "01",
		modulousId: "PAR|01|",
		rgTypes: [
			"Wall"
		],
		rvFamilyName: "basic wall",
		rvFamilyType: "parapet generic",
		totalThickness: 0.185,
		size: [
			null,
			null,
			0.185
		],
		color: "#e6e0c8",
		sizeLock: [
			false,
			false,
			true
		]
	},
	{
		layers: [
			{
				name: "Vegetation Blanket",
				thickness: 0.065
			},
			{
				name: "HyrdoSoil Substrate",
				thickness: 0.06
			},
			{
				name: "Air Infiltration Barrier",
				thickness: 0.01
			},
			{
				name: "Insulation_Generic_Rigid_Beige",
				thickness: 0.355
			},
			{
				name: "Plywood, Sheathing",
				thickness: 0.01
			}
		],
		modCategory: "RFB",
		modType: "01",
		modulousId: "RFB|01|",
		rgTypes: [
			"Roof"
		],
		rvFamilyName: "basic roof",
		rvFamilyType: "roof generic",
		totalThickness: 0.5,
		size: [
			null,
			0.5,
			null
		],
		color: "#ebeced",
		sizeLock: [
			false,
			true,
			false
		]
	},
	{
		layers: [
			{
				name: "Metal Deck",
				thickness: 0.01
			},
			{
				name: "Metal - Steel",
				thickness: 0.15
			}
		],
		modCategory: "BFA",
		modType: "01",
		modulousId: "BFA|01|",
		rgTypes: [
			"Floor"
		],
		rvFamilyName: "floor",
		rvFamilyType: "balcony floor cassette",
		totalThickness: 0.16,
		size: [
			null,
			0.16,
			null
		],
		color: "#5a6772",
		sizeLock: [
			false,
			true,
			false
		]
	},
	{
		layers: [
			{
				name: "Sheathing Board_Generic",
				thickness: 0.0125
			},
			{
				name: "Insulation_Generic_Soft",
				thickness: 0.1
			},
			{
				name: "Fireline Board_Generic",
				thickness: 0.0125
			},
			{
				name: "Fireline Board_Generic",
				thickness: 0.0125
			}
		],
		modCategory: "WPA",
		modType: "01",
		modulousId: "WPA|01|",
		rgTypes: [
			"Wall"
		],
		rvFamilyName: "basic wall",
		rvFamilyType: "perimeter_12.5-100-25",
		totalThickness: 0.1375,
		size: [
			null,
			null,
			0.1375
		],
		color: "#e6e0c8",
		sizeLock: [
			false,
			false,
			true
		]
	},
	{
		layers: [
			{
				name: "Fireline Board_Generic",
				thickness: 0.0125
			},
			{
				name: "Insulation_Generic_Soft",
				thickness: 0.07
			},
			{
				name: "Fireline Board_Generic",
				thickness: 0.0125
			}
		],
		modCategory: "WPB",
		modType: "01",
		modulousId: "WPB|01|",
		rgTypes: [
			"Wall"
		],
		rvFamilyName: "basic wall",
		rvFamilyType: "partition_12.5-70-12.5",
		totalThickness: 0.095,
		size: [
			null,
			null,
			0.095
		],
		color: "#e6e0c8",
		sizeLock: [
			false,
			false,
			true
		]
	},
	{
		layers: [
		],
		modCategory: "DCD",
		modType: "01",
		modulousId: "DCD|01|",
		rgTypes: [
			"Door"
		],
		rvFamilyName: "external door casement double",
		rvFamilyType: "1730x2040",
		totalThickness: 0,
		size: [
			1.75,
			2.085,
			0.1375
		],
		color: "#564c83",
		sizeLock: [
			true,
			true,
			true
		]
	},
	{
		layers: [
		],
		modCategory: "DIS",
		modType: "02",
		modulousId: "DIS|02|",
		rgTypes: [
			"Door"
		],
		rvFamilyName: "internal single door",
		rvFamilyType: "826x2040",
		totalThickness: 0,
		size: [
			0.9099999999999979,
			2.09,
			0.095
		],
		color: "#564c83",
		sizeLock: [
			true,
			true,
			true
		]
	},
	{
		layers: [
		],
		modCategory: "DID",
		modType: "01",
		modulousId: "DID|01|",
		rgTypes: [
			"Door"
		],
		rvFamilyName: "internal double door",
		rvFamilyType: "1210x2040",
		totalThickness: 0,
		size: [
			1.21,
			2.09,
			0.095
		],
		color: "#564c83",
		sizeLock: [
			true,
			true,
			true
		]
	},
	{
		layers: [
			{
				name: "Concrete, Sand/Cement Screed",
				thickness: 0.065
			}
		],
		modCategory: "SCR",
		modType: "01",
		modulousId: "SCR|01|",
		rgTypes: [
			"Floor"
		],
		rvFamilyName: "floor",
		rvFamilyType: "screed deck_65",
		totalThickness: 0.065,
		size: [
			null,
			0.065,
			null
		],
		color: "#5a6772",
		sizeLock: [
			false,
			true,
			false
		]
	},
	{
		layers: [
			{
				name: "Wood_Generic_Satin_Ash",
				thickness: 0.01
			}
		],
		modCategory: "FFN",
		modType: "01",
		modulousId: "FFN|01|",
		rgTypes: [
			"Floor"
		],
		rvFamilyName: "floor",
		rvFamilyType: "floor finish_10",
		totalThickness: 0.01,
		size: [
			null,
			0.01,
			null
		],
		color: "#5a6772",
		sizeLock: [
			false,
			true,
			false
		]
	},
	{
		layers: [
			{
				name: "Metal - Steel 43-275"
			}
		],
		modCategory: "LAU",
		modType: "01",
		modulousId: "LAU|01|",
		rgTypes: [
			"Beam"
		],
		rvFamilyName: "l-unequal leg angles [framing]",
		rvFamilyType: "l100x75x10",
		size: [
			null,
			0.10000000149011612,
			0.07499980926513672
		],
		color: "#8e3939",
		sizeLock: [
			false,
			true,
			true
		]
	},
	{
		layers: [
			{
				name: "Metal - Steel 43-275"
			}
		],
		modCategory: "PFC",
		modType: "01",
		modulousId: "PFC|01|",
		rgTypes: [
			"Column"
		],
		rvFamilyName: "pfc-parallel flange channels [column]",
		rvFamilyType: "pfc180x90x26",
		size: [
			0.18000006675720218,
			2.747499942779541,
			0.08999999612569813
		],
		color: "#8e3939"
	},
	{
		layers: [
			{
				name: "Sheathing Board_Generic",
				thickness: 0.018
			},
			{
				name: "Insulation_Generic_Soft",
				thickness: 0.107
			},
			{
				name: "Fireline Board_Generic",
				thickness: 0.015
			},
			{
				name: "Fireline Board_Generic",
				thickness: 0.015
			}
		],
		modCategory: "CPA",
		modType: "05",
		modulousId: "CPA|05|",
		rgTypes: [
			"Ceiling"
		],
		rvFamilyName: "basic roof",
		rvFamilyType: "18-100-30",
		totalThickness: 0.155,
		size: [
			null,
			0.155,
			null
		],
		color: "#5ea0bb",
		sizeLock: [
			false,
			true,
			false
		]
	},
	{
		layers: [
		],
		modCategory: "DES",
		modType: "01",
		modulousId: "DES|01|",
		rgTypes: [
			"Door"
		],
		rvFamilyName: "entrance door",
		rvFamilyType: "926x2040",
		totalThickness: 0,
		size: [
			1.01,
			2.09,
			0.1375
		],
		color: "#564c83",
		sizeLock: [
			true,
			true,
			true
		]
	},
	{
		layers: [
		],
		modCategory: "DIS",
		modType: "03",
		modulousId: "DIS|03|",
		rgTypes: [
			"Door"
		],
		rvFamilyName: "arnold laver - single internal door",
		rvFamilyType: "926x2040 (fd0)",
		totalThickness: 0,
		size: [
			1,
			2.085,
			0.095
		],
		color: "#564c83",
		sizeLock: [
			true,
			true,
			true
		]
	},
	{
		layers: [
		],
		modCategory: "WNF",
		modType: "12",
		modulousId: "WNF|12|",
		rgTypes: [
			"Window"
		],
		rvFamilyName: "window fixed",
		rvFamilyType: "1730x1275",
		totalThickness: 0,
		size: [
			1.76,
			1.305,
			0.1375
		],
		color: "#4b5e82",
		sizeLock: [
			true,
			true,
			true
		]
	},
	{
		layers: [
		],
		modCategory: "WNF",
		modType: "14",
		modulousId: "WNF|14|",
		rgTypes: [
			"Window"
		],
		rvFamilyName: "window fixed",
		rvFamilyType: "1120x1275",
		totalThickness: 0,
		size: [
			1.15,
			1.305,
			0.1375
		],
		color: "#4b5e82",
		sizeLock: [
			true,
			true,
			true
		]
	},
	{
		layers: [
		],
		modCategory: "WNF",
		modType: "13",
		modulousId: "WNF|13|",
		rgTypes: [
			"Window"
		],
		rvFamilyName: "window fixed",
		rvFamilyType: "820x1275",
		totalThickness: 0,
		size: [
			0.85,
			1.305,
			0.1375
		],
		color: "#4b5e82",
		sizeLock: [
			true,
			true,
			true
		]
	}
];

export { data as default };
//# sourceMappingURL=combined-rv-data.json.js.map
